module.exports = "pegasus/assets/blocks/column-2-basic.png";